const ROLE_ADMINISTRATOR = 'beststart.paymint.admin';
const ROLE_SUPER_ADMINISTRATOR = 'beststart.paymint.superadmin';
const ROLE_ADMIN_SUPPORT = 'beststart.paymint.readonly';
const ROLE_FINANCE = 'beststart.paymint.finance';
const ROLE_CENTRE_ADMIN = 'beststart.paymint.centreadmin';

const ALL_ROLES = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_ADMIN_SUPPORT,
    ROLE_FINANCE,
    ROLE_CENTRE_ADMIN
];

const ADMINS = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
]

const SUPPORT = [
    ...ADMINS,
    ROLE_ADMIN_SUPPORT
]

const FINANCE = [
    ROLE_FINANCE
]

const CENTRE_ADMIN = [
    ...ADMINS,
    ROLE_ADMIN_SUPPORT,
    ROLE_CENTRE_ADMIN
]

const roles = {
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_ADMINISTRATOR,
    ROLE_ADMIN_SUPPORT,
    ROLE_FINANCE,
    ROLE_CENTRE_ADMIN,
    SUPPORT,
    ALL_ROLES,
    ADMINS,
    FINANCE,
    CENTRE_ADMIN
};

export default roles;